module.exports = __webpack_public_path__ + "media/navigation/icon-book-bf235c86.svg";